export default class CommonAction {
  static ACTION_TYPES = {
    // Async actions
    // -- Fetch
    FETCH_ERROR: 'common/FETCH_ERROR',
    FETCH_START: 'common/FETCH_START',
    FETCH_SUCCESS: 'common/FETCH_SUCCESS',
    // -- Other
    WINDOW_WIDTH: 'common/WINDOW_WIDTH',
    // Sync actions
    HIDE_MESSAGE: 'common/HIDE_MESSAGE',
    SHOW_MESSAGE: 'common/HIDE_MESSAGE',
    TOGGLE_COLLAPSED_NAV: 'TOGGLE_COLLAPSED_NAV',
  };

  static fetchStart = () => ({
    type: CommonAction.ACTION_TYPES.FETCH_START,
  });

  static fetchSuccess = () => ({
    type: CommonAction.ACTION_TYPESFETCH_SUCCESS,
  });

  static fetchError = (error) => ({
    type: CommonAction.ACTION_TYPES.FETCH_ERROR,
    payload: error,
  });

  static setWindowWidth = (payload) => ({
    type: CommonAction.ACTION_TYPES.WINDOW_WIDTH,
    payload,
  });

  static showMessage = (message) => ({
    type: CommonAction.ACTION_TYPES.SHOW_MESSAGE,
    payload: message,
  });

  static hideMessage = () => ({
    type: CommonAction.ACTION_TYPES.HIDE_MESSAGE,
  });
}
